import React from 'react'
export const ClientListContext = React.createContext([
  {
    id: 0,
    title: 'Keine AOK vorhanden',
    shortcut: '',
    url: '#',
  },
])
